// components/Header.jsx
import React from 'react';
import Logo from '../assets/logo2.png';

export default function Header() {
  return (
    <div className="bg-white flex justify-between items-center px-6 py-4 shadow">
      <div className="flex items-center space-x-4">
        <img src={Logo} alt="Secretaria de Saúde" className="h-14" />
        <div>
          <h1 className="text-green-700 font-bold text-xl">Secretaria Municipal de Saúde</h1>
          <p className="text-sm text-gray-600">Prefeitura de Ceres - GO</p>
        </div>
      </div>
      <div className="text-right">
        <p className="text-sm text-gray-700">Atendimento: (62) 3307-7600</p>
        <p className="text-sm">Seg a Sex - 7h às 17h</p>
      </div>
    </div>
  );
}